import { api } from '../api';

const doAddSuggestion = api.path('/api/suggestion').method('post').create();
export async function addSuggestion(suggestion: string) {
    await doAddSuggestion({ suggestion });
}
